module.exports = __webpack_public_path__ + "img/crush-logo.395ed7b9.png";